export default __webpack_public_path__ + "static/media/Group254.0a819895.png";